import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar, { MobileHeader } from './Sidebar';
import { Toaster } from '../ui/sonner';

const MainLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="spinner h-12 w-12" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/crm" replace />;
  }

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile Header */}
        <MobileHeader onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Main Content */}
        <main className="flex-1 overflow-x-hidden">
          <div className="p-4 lg:p-6 xl:p-8 max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
      
      <Toaster position="top-right" />
    </div>
  );
};

export default MainLayout;
